import React from 'react'
import { Menu } from 'semantic-ui-react'
import { react_app_inverted } from '../utils'

export default ({ children, widths }) => (
  <Menu size='tiny' inverted={react_app_inverted()} color={process.env.REACT_APP_PRIMARY_COLOR} icon="labeled" fixed="top" fluid widths={widths}>
    {children}
  </Menu>
)